import React from 'react';
import { ArrowRight, ArrowUpRight, Lock } from 'lucide-react';
import { bundles } from '../../data/blackout';
import { useBundle } from '../../contexts/BundleContext';
import { goToCheckout } from '../../utils/checkout';
import { formatPrice } from '../../utils/currency';
import { BundleCard } from './BundleCard';
export function BundleSection() {
  const {
    selected,
    selectBundle,
    showCrystalBonus
  } = useBundle();
  const index = bundles.findIndex(b => b.id === selected.id);
  const next = bundles[index + 1];
  const savings = selected.regularPrice - selected.price;
  return <section id="bundles" className="border-t-2 border-bone/80 bg-obsidian py-20 md:py-28" data-id="element-82" data-mp="ia6q9u0kaese">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-83" data-mp="n99sz7t2k8x7">
        <div className="mb-10 flex flex-col gap-3 md:mb-12 md:flex-row md:items-end md:justify-between" data-id="element-84" data-mp="na1hjyo916dz">
          <h2 className="font-display text-5xl uppercase leading-[0.95] text-bone md:text-7xl" data-id="element-85" data-mp="1totwc0a4bx3k">
            Choose your chapter.
          </h2>
          <p className="text-[12px] font-medium uppercase tracking-[0.3em] text-steel" data-id="element-86" data-mp="1by6cpw3wc8kf">
            More masks. More stories. More value.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-12" data-id="element-87" data-mp="1704x5l5oirdp">
          <div role="radiogroup" aria-label="Choose a bundle" className="grid gap-3 sm:grid-cols-2 lg:col-span-8" data-id="element-88" data-mp="12wys2guaz68t">
            {bundles.map(bundle => <BundleCard key={bundle.id} bundle={bundle} selected={bundle.id === selected.id} showBonus={showCrystalBonus} onSelect={() => selectBundle(bundle.id)} data-id="element-89" data-mp="szu54esmv6qy" />)}
          </div>

          {/* Selected summary + the $30 step up */}
          <aside className="lg:col-span-4" data-id="element-90" data-mp="f62s2wfp14qh">
            <div className="border border-bone/50 bg-carbon p-5 md:p-6 lg:sticky lg:top-24" data-id="element-91" data-mp="a9m6a8vyv2gk">
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-steel" data-id="element-92" data-mp="59g8sc30mlqk">
                Your unit
              </p>
              <p className="mt-2 font-display text-3xl uppercase leading-none text-bone" data-id="element-93" data-mp="3rq6u5zk5csp5">
                {selected.name}
              </p>

              <dl className="mt-5 divide-y divide-gunmetal border-y border-gunmetal text-sm" data-id="element-94" data-mp="3htlp5e84nhlb">
                <div className="flex justify-between py-2.5" data-id="element-95" data-mp="3msotewga9js8">
                  <dt className="text-steel" data-id="element-96" data-mp="3mt6x2e59z0a6">Masks</dt>
                  <dd className="font-semibold text-bone" data-id="element-97" data-mp="ecbu6yoh9fw3">{selected.count}</dd>
                </div>
                <div className="flex justify-between py-2.5" data-id="element-98" data-mp="jchqwt9ltsl1">
                  <dt className="text-steel" data-id="element-99" data-mp="je14ud7sfrjn">Per mask</dt>
                  <dd className="text-bone" data-id="element-100" data-mp="4m0rtgkfzerb">{formatPrice(selected.price / selected.count)}</dd>
                </div>
                <div className="flex justify-between py-2.5" data-id="element-101" data-mp="9kkcldnauki3">
                  <dt className="text-steel" data-id="element-102" data-mp="xb7mg4grzk7a">You save</dt>
                  <dd className="text-bone" data-id="element-103" data-mp="x9mu8lhxodcl">{savings > 0 ? formatPrice(savings) : '—'}</dd>
                </div>
                <div className="flex justify-between py-2.5" data-id="element-104" data-mp="124agedpgsvo0">
                  <dt className="text-steel" data-id="element-105" data-mp="2mra81l0jkerf">Shipping</dt>
                  <dd className="text-bone" data-id="element-106" data-mp="2hua2rcbing1d">
                    {selected.shipping === 'free' ? 'Free (U.S.)' : 'Calculated at checkout'}
                  </dd>
                </div>
                {showCrystalBonus && selected.bonus && <div className="flex justify-between gap-4 py-2.5" data-id="element-107" data-mp="2rk3c06o6rj2g">
                    <dt className="text-steel" data-id="element-108" data-mp="23t7fwxcp61pe">Bonus</dt>
                    <dd className="text-right text-bone" data-id="element-109" data-mp="23vtv9j5txli6">{selected.bonus}</dd>
                  </div>}
              </dl>

              <div className="mt-5 flex items-baseline justify-between" data-id="element-110" data-mp="2cuxfwrkna8ys">
                <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-steel" data-id="element-111" data-mp="28t3jivhhfr4f">
                  Total
                </span>
                <span className="flex items-baseline gap-2" data-id="element-112" data-mp="3o8j2c4z4dwgm">
                  {savings > 0 && <span className="text-sm text-steel line-through" data-id="element-113" data-mp="3k7h3hp947mf6">
                      {formatPrice(selected.regularPrice)}
                    </span>}
                  <span className="font-display text-4xl leading-none text-bone" data-id="element-114" data-mp="nduv46trj3w6">
                    {formatPrice(selected.price)}
                  </span>
                </span>
              </div>

              <button type="button" onClick={() => goToCheckout(selected)} className="group mt-5 inline-flex h-14 w-full items-center justify-center gap-3 bg-bone text-[13px] font-semibold uppercase tracking-[0.2em] text-obsidian transition-[background-color,transform] duration-150 ease-out hover:bg-white active:scale-[0.98]" data-id="element-115" data-mp="xd2ilmu7oex0">
                {selected.cta}
                <ArrowRight className="h-4 w-4" aria-hidden="true" data-id="element-116" data-mp="1g1z4p3fgg145" />
              </button>

              {next && <button type="button" onClick={() => selectBundle(next.id)} className="mt-3 flex w-full items-center justify-between gap-3 border border-dashed border-steel/60 px-4 py-3 text-left transition-colors duration-150 hover:border-bone" data-id="element-117" data-mp="1l47x9yof115q">
                  <span className="text-[13px] leading-snug text-bone/90" data-id="element-118" data-mp="35ms77h2s52e6">
                    <span className="font-semibold text-bone" data-id="element-119" data-mp="30lkynfstbz6g">
                      Only {formatPrice(next.price - selected.price)} more
                    </span>{' '}
                    → {next.count - selected.count} more masks
                    {selected.shipping !== 'free' && next.shipping === 'free' && ' + free shipping'}
                    {showCrystalBonus && !selected.bonus && next.bonus && ' + bonus crystals'}
                  </span>
                  <ArrowUpRight className="h-4 w-4 shrink-0 text-bone" aria-hidden="true" data-id="element-120" data-mp="3elnbgnm9k2eu" />
                </button>}

              <p className="mt-4 flex items-center justify-center gap-2 text-[12px] text-steel" data-id="element-121" data-mp="fwokbm0h66ng">
                <Lock className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-122" data-mp="b2u44sk2w9t4" />
                Secure checkout · Free masks applied automatically
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>;
}